<div class="o-grid o-grid--center-h o-grid--wrap">
	<div class="o-grid__cell o-grid__cell--w-100 u-no-p@up-to-md">
		<section class="c-section c-section--open">
			<div class="c-section__content">
				<div class="c-card">
					<div class="c-content c-content--xxl" *ngIf="vm.isInitialized">
						<div class="o-grid o-grid--center-h">
							<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-70@md-and-up u-no-p">
								<div>
									<p class="c-text c-text--lg u-osb-lg">{{ 'Booking.Instant.Mental_Intro' | translate }}</p>
									<ul class="c-list c-list--unstyled">
										<li>
											<div id="chatWithConsultantElement" (click)="vm.goToConciergeFlow()" style="min-height:100px" class="o-grid o-grid--center-v c-content c-content--border-bottom u-no-ph c-text c-text--s6 u-clickable">
												<div class="o-grid__cell u-no-pl">
													<p class="c-text u-osb-sm">{{ 'Booking.Instant.Mental_Consultant_Title' | translate }}<span *ngIf="vm.info">. {{ vm.info }}</span></p>
													<p class="c-text {{vm.textColor}} c-text--sm">{{ 'Booking.Instant.Mental_Consultant_Description' | translate }}</p>
												</div>
												<div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
													<i class="o-icon o-icon--angle-r" aria-hidden="true"></i>
												</div>
											</div>
										</li>
                                        <li>
                                            <div id="myWellbeingProfileElement" (click)="vm.goToMyWellbeingProfile()" style="min-height:100px" class="o-grid o-grid--center-v c-content c-content--border-bottom u-no-ph c-text c-text--s6 u-clickable">
                                                <div class="o-grid__cell u-no-pl">
                                                    <p class="c-text u-osb-sm">{{ 'MyMentalProfile.Title' | translate }}</p>
                                                    <p class="c-text {{vm.textColor}} c-text--sm">{{ 'MyMentalProfile.Info_Generic' | translate }}<br/>&nbsp;</p>
                                                </div>
                                                <div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
                                                    <i class="o-icon o-icon--angle-r" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div id="meditationActivationElement" (click)="vm.goToMeditationActivation()" style="min-height:100px" class="o-grid o-grid--center-v c-content c-content--border-bottom u-no-ph c-text c-text--s6 u-clickable">
                                                <div class="o-grid__cell u-no-pl">
                                                    <p class="c-text u-osb-sm">{{ 'Meditation.Title' | translate }}</p>
                                                    <p class="c-text {{vm.textColor}} c-text--sm">{{ (vm.origin == 'siffi.com' ? 'Meditation.Intro_Siffi' : 'Meditation.Intro_MinuDoc') | translate }}</p>
                                                </div>
                                                <div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
                                                    <i class="o-icon o-icon--angle-r" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </li>
										<li>
											<div id="followUpElement" (click)="vm.goToFollowUpHistory()" style="min-height:100px" class="o-grid o-grid--center-v c-content c-content--border-bottom u-no-ph c-text c-text--s6 u-clickable">
												<div class="o-grid__cell u-no-pl">
													<p class="c-text u-osb-sm">{{ 'Booking.Instant.Mental_Follow_Up_Title' | translate }}</p>
													<p class="c-text {{vm.textColor}} c-text--sm">{{ 'Booking.Instant.Mental_Follow_Up_Description' | translate }}</p>
												</div>
												<div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
													<i class="o-icon o-icon--angle-r" aria-hidden="true"></i>
												</div>
											</div>
										</li>
                                        <li>
                                            <div id="audiobooksElement" (click)="vm.goToAudiobooks()" style="min-height:100px" class="o-grid o-grid--center-v c-content u-no-ph c-text c-text--s6 u-clickable">
                                                <div class="o-grid__cell u-no-pl">
                                                    <p class="c-text u-osb-sm">{{ 'Audiobooks.Title' | translate }}</p>
                                                    <p class="c-text {{vm.textColor}} c-text--sm">{{ 'Audiobooks.Info_Short' | translate }}<br/>&nbsp;</p>
                                                </div>
                                                <div class="o-grid__cell u-no-pr o-grid__cell--w-fixed">
                                                    <i class="o-icon o-icon--angle-r" aria-hidden="true"></i>
                                                </div>
                                            </div>
                                        </li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<loader-overlay *ngIf="vm.isProcessing || !vm.isInitialized"></loader-overlay>
				</div>
			</div>
		</section>
	</div>
</div>
